//
// Short version of https://github.com/pwhisenhunt/Backbonejs-Router-Title-Helper
//

var log = require('lib/log')('title-helper');

function init(options) {
    var originalRoute = Backbone.Router.prototype.route;
    var base = options.base || '';

    _.extend(Backbone.Router.prototype, {
        _setTitle: function(route) {
            var title = this.titles[route];
            var newTitle;

            if (_.isUndefined(title) && _.isUndefined(this.titles.default)) {
                log.warn('No title found. No default provided.');
                title = '';
            }

            if (_.isString(title)) {
                newTitle = title;
            } else {
                newTitle = this.titles.default;
            }

            document.title = base + ' ' + newTitle;

            this.trigger('change:title', route, newTitle);
        },

        route: function(route, name, callback) {
            var wrappedCallback = function() {
                if (!callback) {
                    callback = this[name];
                }

                if (this.titles) {
                    this._setTitle(route);
                }

                callback.apply(this, arguments);
            };

            return originalRoute.call(this, route, name, wrappedCallback);
        }
    });
}

module.exports = init;



// WEBPACK FOOTER //
// ./app/helpers/title.js